import './index.css'
import './i18n'

import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { v4 as uuidv4 } from 'uuid'

import configsToStorageService from './api/configs-to-storage.service.ts'
import { App } from './app.tsx'
import { env } from './env.ts'

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  tracesSampleRate: 1.0,
  enabled: env.VITE_ENV === 'production',
  release: `bento-portal@${__APP_VERSION__}`,
  environment: env.VITE_ENV,
})

const deviceId = configsToStorageService.getDeviceId()
if (!deviceId) {
  const newDeviceId = uuidv4()
  configsToStorageService.saveDeviceId(newDeviceId)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
